// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__dDLDf","spin":"Spinner_spin__y3Xq9","spinner-sm":"Spinner_spinner-sm__+j0iI Spinner_spinner__dDLDf"};